module.exports = __webpack_public_path__ + "img/Access Denied.f13406e8.svg";